import { MenuList, MenuListProps } from "@mui/material";

export type SHMenuListProps = MenuListProps;
export const SHMenuList = (props: MenuListProps): JSX.Element => (
    <MenuList {...props} />
);
